import keys from "config/keys.jsx";
import { appendPathSegments, executeApiRequest } from "./httpClient";

export const appendPath = appendPathSegments;

export const executeActionRequest = (endpoint, options = {}) => (
  executeApiRequest(keys.URL, endpoint, options)
);

export const unwrapApiData = (payload) => {
  if (payload && Object.prototype.hasOwnProperty.call(payload, "data")) {
    return payload.data;
  }
  return payload;
};

export const rejectWithError = (error) => Promise.reject(error?.payload || error);

export const dispatchAndResolve = (dispatch, type, payload) => {
  dispatch({ type, payload });
  return Promise.resolve(payload);
};

export const dispatchFailure = (dispatch, type, error) => {
  dispatch({ type, payload: error });
  return Promise.reject(error);
};
